
const Matomo = async (title) =>{
    await window._paq.push(['setCustomUrl', '/' + title]);
    await window._paq.push(['setDocumentTitle', title]);
    await window._paq.push(['trackPageView']); 
    console.log('Matomo componentdidmount: ' + title);
    return;
}

export default Matomo;